/** OAuth 2.0 PKCE (RFC 7636, S256) and state helpers. */
import { b64url, utf8 } from './b64.js';

export function randomVerifier(): string {
  return b64url(crypto.getRandomValues(new Uint8Array(32))); // 43 chars
}

export async function pkceChallenge(verifier: string): Promise<string> {
  return b64url(new Uint8Array(await crypto.subtle.digest('SHA-256', utf8(verifier))));
}

export const randomState = (): string => b64url(crypto.getRandomValues(new Uint8Array(16)));

/** Message the OAuth redirect page posts back to its opener. */
export interface OAuthMessage {
  type: 'mp-oauth';
  state: string | null;
  code: string | null;
  error: string | null;
}

/**
 * Run on the redirect_uri page opened in the popup: hand the code to the opener
 * (same origin only) and close.
 */
export function completeOAuthPopup(win: Window = window): void {
  const q = new URLSearchParams(win.location.search);
  const msg: OAuthMessage = { type: 'mp-oauth', state: q.get('state'), code: q.get('code'), error: q.get('error') };
  win.opener?.postMessage(msg, win.location.origin);
  win.close();
}
